/**
 * https://gist.github.com/aarongeorge/80b66cf141261d70816b4b49ccf02578
 *
 * @param date
 * @param options
 * @returns {Date}
 */
const modifyDate = (date, options) => {
  const modifiedDate = new Date(date);

  if (options.years) modifiedDate.setFullYear(modifiedDate.getFullYear() + options.years);
  if (options.months) modifiedDate.setMonth(modifiedDate.getMonth() + options.months);
  if (options.weeks) modifiedDate.setDate(modifiedDate.getDate() + options.weeks * 7);
  if (options.days) modifiedDate.setDate(modifiedDate.getDate() + options.days);
  if (options.hours) modifiedDate.setHours(modifiedDate.getHours() + options.hours);
  if (options.minutes) modifiedDate.setMinutes(modifiedDate.getMinutes() + options.minutes);
  if (options.seconds) modifiedDate.setSeconds(modifiedDate.getSeconds() + options.seconds);
  if (options.milliseconds) modifiedDate.setMilliseconds(modifiedDate.getMilliseconds() + options.milliseconds);

  return modifiedDate;
};

/**
 *
 * @param {Date} date
 * @returns {string}
 */
const dateToStr = date => `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

/**
 *
 * @param {function} fn
 * @param {Date} date
 * @returns {number}
 */
const setTimeoutToDate = (fn, date) => {
  const now = new Date().getTime();
  const diff = date.getTime() - now;
  return setTimeout(fn, diff);
};

export {
  modifyDate,
  dateToStr,
  setTimeoutToDate
};
